/* LBT homepage: shared behaviour for lbt- homepage sections.
   Reveal on scroll (by scroll position, not IntersectionObserver, so a missed callback can never leave content hidden). */
(function () {
  if (window.lbtHome) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending = [];
  function collect() {
    pending = [].slice.call(document.querySelectorAll('[data-lbt-reveal]:not(.is-in)'));
  }
  function frame() {
    var h = window.innerHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      var b = pending[i].getBoundingClientRect();
      if (b.top < h * 0.9 && b.bottom > 0) { pending[i].classList.add('is-in'); pending.splice(i, 1); }
    }
  }
  var ticking = false;
  function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; frame(); }); }
  window.lbtHome = {
    refresh: function () { collect(); frame(); }
  };
  if (reduce) return;
  document.documentElement.classList.add('lbt-anim');
  function boot() { collect(); frame(); setTimeout(frame, 400); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', frame);
  /* theme editor: re-scan when a section is added or re-rendered */
  document.addEventListener('shopify:section:load', function () { collect(); frame(); });
})();
